module.exports = __webpack_public_path__ + "img/top-pain-2.a9ab5386.svg";